export default {"src":"/_next/static/media/FinancialIcon.5ca50c4b.svg","height":20,"width":16};